<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre3">Introduction: Reading the News in Order to Love Our Neighbors</a></div>
<div class="SOM_part"><a href="#/p1">Part 1: Attention</a></div>
<div class="SOM_chap"><a href="#/p1chap1"><b>1</b> Macadamized Mind</a></div>
<div class="SOM_chap"><span href="#/p1chap2" title="Link target outside of Sample"><b>2</b> The Blessed Man as a Rooted Tree</span></div>
<div class="SOM_chap"><span href="#/p1chap3" title="Link target outside of Sample"><b>3</b> Liturgies of Attention</span></div>
<div class="SOM_part"><span href="#/p2" title="Link target outside of Sample">Part 2: Time</span></div>
<div class="SOM_chap"><span href="#/p2chap1" title="Link target outside of Sample"><b>4</b> Kairos Versus Chronos</span></div>
<div class="SOM_chap"><span href="#/p2chap2" title="Link target outside of Sample"><b>5</b> Figural Imagination</span></div>
<div class="SOM_chap"><span href="#/p2chap3" title="Link target outside of Sample"><b>6</b> Liturgies of Christian Time</span></div>
<div class="SOM_part"><span href="#/p3" title="Link target outside of Sample">Part 3: Community</span></div>
<div class="SOM_chap"><span href="#/p3chap1" title="Link target outside of Sample"><b>7</b> Belonging in the Public Sphere</span></div>
<div class="SOM_chap"><span href="#/p3chap2" title="Link target outside of Sample"><b>8</b> Belonging Outside the Public Sphere</span></div>
<div class="SOM_chap"><span href="#/p3chap3" title="Link target outside of Sample"><b>9</b> Liturgies of Christian Belonging</span></div>
<div class="SOM_appen"><span href="#/appen4" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/appen5" title="Link target outside of Sample">General Index</span></div>
<div class="SOM_appen"><span href="#/appen6" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen7" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Praise for <i>Reading the Times</i></span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?6ca286ee